// Oct 2026 (TRIAL_PLAN.md D36) — the frontend mirror of the backend's
// role_helpers.has_platform_access(). ONE function decides "can this account
// use the Creator Dashboard right now": paid, comped, super-admin, or on a
// live 14-day trial. Before this, App.js, Login.jsx, FanPortal.jsx and
// useViewerSurface.js each hand-rolled the same three-clause expression, so a
// new access state had to be added in four places or the user ended up with
// unlocked tools and no dashboard to use them in.
//
// `is_paid_creator` still means MONEY (or a comp). Never use it to decide
// routing, and never use this to describe someone as a paying customer.

export function hasPlatformAccess(user) {
  if (!user) return false;
  if (typeof user.has_platform_access === "boolean") return user.has_platform_access;
  // Legacy cached user object (stored in localStorage before the field
  // existed) — fall back to the pre-trial rule so a stale blob can never
  // lock a paying creator out of their own dashboard.
  return !!(
    user.is_paid_creator ||
    user.platform_subscription_status === "active" ||
    user.role === "super_admin"
  );
}

export function isTrialing(user) {
  return !!(user && user.is_trialing);
}
